import style from './ComponentItem.module.scss';
import '@components/mixins/commonStyles.scss';

export interface ComponentItemProps {
    id: string;
    title: string;
    componentProps: any;
    Component: React.ComponentType<any>;
    children: React.ReactNode;
    fields?: {
        themes: any[];
        modifiers: any[];
    };
}

export function ComponentItem({ id, title, Component, componentProps, fields, children }: ComponentItemProps) {
    return (
        <div
            id={id}
            className={style.root}
        >
            <div className={'font_h1'}>{title}</div>
            <div className={style.list}>
                {componentProps &&
                    componentProps.map((props: any, index: number) => (
                        <Component
                            key={index}
                            {...props}
                        />
                    ))}
            </div>
            {fields && (
                <>
                    <div>
                        <div className={'font_h2'}>Themes: </div>
                        <div className={style.list}>
                            {fields &&
                                fields.themes.map((props, index) => (
                                    <Component
                                        key={index}
                                        {...props}
                                    />
                                ))}
                        </div>
                    </div>
                    <div>
                        <div className={'font_h2'}>Modifiers: </div>
                        <div className={style.list}>
                            {fields &&
                                fields.modifiers.map((props, index) => (
                                    <Component
                                        key={index}
                                        {...props}
                                    />
                                ))}
                        </div>
                    </div>
                </>
            )}
            <div className={style.additional}>{children}</div>
        </div>
    );
}
